export const blockIconsNavigationArrowDropUp = (
	<span className='material-symbols-outlined'>arrow_drop_up</span>
);
